import { ServiceBase } from '../../../../core/services/ServiceBase'
import ScoreCompanyProxy from './proxy'

class ScoreCompanyService extends ServiceBase {
  getHightLight(params) {
    return this.getData(() => ScoreCompanyProxy.getHightLight(params))
  }
}

export default new ScoreCompanyService()
